// Extract short, buyer-facing spec badges strictly from the product's own
// stored data (specifications dict + description). No invented values —
// a badge is shown only if the token actually appears in the product.
const PATTERNS = [
  { label: "5G", regex: /\b5G\b/ },
  { label: "IP69K", regex: /\bIP69K?\b/i },
  { label: "IP68", regex: /\bIP68\b/i, skipIfSeen: ["IP69K"] },
  { fmt: (m) => `${m[1]} mAh`, regex: /(\d{3,6})\s*mAh/i },
  { fmt: (m) => `${m[1]}Hz`,  regex: /(\d{2,3})\s*Hz/i },
  { fmt: (m) => `${m[1]}MP`,  regex: /(\d{2,3})\s*MP/i },
  { fmt: (m) => `${m[1]}W`,   regex: /(\d{2,3})\s*W(\b|$)/i },
  { label: "Dual SIM", regex: /\bdual[- ]?sim\b/i },
  { label: "FLIR Thermal", regex: /\bFLIR\b/i },
  { label: "Rugged", regex: /\brugged\b/i },
];

export function extractBadges(product, max = 4) {
  const specs = product?.specifications || {};
  const values = Object.values(specs).filter(Boolean).map(String);
  const keys = Object.keys(specs).map(String);
  const haystack = [...keys, ...values, product?.description || ""].join(" | ");
  const out = [];
  const seen = new Set();
  for (const p of PATTERNS) {
    if (p.skipIfSeen && p.skipIfSeen.some((s) => seen.has(s))) continue;
    const m = haystack.match(p.regex);
    if (!m) continue;
    const label = p.label || p.fmt(m);
    if (seen.has(label)) continue;
    seen.add(label);
    out.push(label);
    if (out.length >= max) break;
  }
  return out;
}
